import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
    selector: 'app-comanage-subnav',
    templateUrl: './comanage-subnav.component.html',
    styleUrls: ['./comanage-subnav.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false,
})
export class ComanageSubnavComponent {}
